import { AppRoute } from '../route'
import { AppStore } from '../../store'
import { fetchGrunndata } from '../../store/actions/grunndata'
import { getStringOrThrow, getValgtype, RouteParam } from '../../../lib/simple-routing/params'
import { fetchDataForWidget } from '../../store/actions'
import { h } from 'preact'
import { WidgetFrame } from '../../components/frames/WidgetFrame/WidgetFrame'
import { selectGeografi } from '../../store/selectors/grunndata'
import { ResultatContainer } from '../../components/resultater/Resultat/Resultat'
import { HasMandater } from '../../components/shared/HasMandater/HasMandater'
import { BeholderDeFlertallet } from '../../components/moduler/BeholderDeFlertallet/BeholderDeFlertallet'
import { PartiResultatMedMandat } from '../../domain'
import { WidgetFooter } from '../../components/shared/WidgetFooter/WidgetFooter'

export const beholderDeFlertalletRoute: AppRoute = {
  path: `/valg/2019/resultat/widget/:locale/beholder-de-flertallet/:valgtype(kommune|fylke)/:id([0-9]{4})`,
  widget: true,
  widgetTitle() {
    return 'Beholder de flertallet'
  },
  onLoad: async (store: AppStore) => {
    return store.dispatch(fetchGrunndata())
  },
  onRouteChanged: async (store: AppStore, params: RouteParam[]) => {
    const paramId = getStringOrThrow(params, 'id')
    const valgtype = getValgtype(params)

    const geo = selectGeografi(store.getState(), paramId)
    if (!(valgtype === 'kommune' && geo.type === 'Kommune')) {
      throw new Error(
        `Beholder de flertallet er ikke støttet for valgtype ${valgtype} og geografi ${geo.key}`
      )
    }
    return store.dispatch(fetchDataForWidget(geo, valgtype))
  },
  render: () => {
    return (
      <WidgetFrame>
        <ResultatContainer type="kommune">
          {(resultat, geografi) => {
            const { partier = [], mandater, flertall } = resultat
            return (
              <HasMandater partier={partier} antall={mandater && mandater.antall}>
                <BeholderDeFlertallet
                  geografi={geografi}
                  partier={partier as PartiResultatMedMandat[]}
                  mandater={mandater}
                  flertall={flertall}
                  widgetFooter={<WidgetFooter resultat={resultat} valgtype="kommune" />}
                />
              </HasMandater>
            )
          }}
        </ResultatContainer>
      </WidgetFrame>
    )
  }
}
